import React from 'react'

export default function BackButtonSvg() {
    return (
                <svg
                  className="mr-3"
                  xmlns="http://www.w3.org/2000/svg"
                  width="10.977"
                  height="7.321"
                  viewBox="0 0 10.977 7.321"
                >
                  <path
                    id="Icon_ionic-ios-arrow-round-back"
                    data-name="Icon ionic-ios-arrow-round-back"
                    d="M11.859,11.392a.5.5,0,0,1,0,.7L9.548,14.415h8.819a.5.5,0,0,1,0,.991H9.548l2.318,2.322a.5.5,0,0,1,0,.7.494.494,0,0,1-.7,0L8.023,15.262h0a.557.557,0,0,1-.1-.156.473.473,0,0,1-.038-.191.5.5,0,0,1,.141-.347L11.165,11.4A.486.486,0,0,1,11.859,11.392Z"
                    transform="translate(-7.882 -11.252)"
                    fill="#fff"
                  />
                </svg>
    )
}
